import * as CL from '@design-system/component-library';
import { Link } from 'react-router';
import { dsClass } from '../../../common/constants/dsClasses';
import { scheduledChangeDisclaimerMsg, scheduledChangeMsg, t, viewChangeRequestDetailsMsg } from '../../../common/i18n';

interface DeviceScheduledChangeDisclaimerProps {
  scheduledChangeUrl?: string;
}

export const DeviceScheduledChangeDisclaimer = ({ scheduledChangeUrl }: DeviceScheduledChangeDisclaimerProps) => (
  <CL.Disclaimer
    className={dsClass.MARGIN_BOTTOM_2}
    disclaimerType="warning"
    visible
    icon={<CL.Icon icon="notification" />}
    title={t.N4LE(scheduledChangeMsg)}
  >
    {t.UM4L(scheduledChangeDisclaimerMsg)}
    {scheduledChangeUrl && (
      <Link className={dsClass.DISPLAY_BLOCK} to={scheduledChangeUrl}>
        {t.CGXR(viewChangeRequestDetailsMsg)}
      </Link>
    )}
  </CL.Disclaimer>
);

export const DeviceChangeRequestDisclaimer = () => (
  <CL.Disclaimer
    className={dsClass.MARGIN_BOTTOM_2}
    disclaimerType="warning"
    visible
    icon={<CL.Icon icon="notification" />}
    title={t.H0XT('Change request in process')}
    text={t.D7Y7(
      `Change request for this device is currently in process. You can't make new changes until the previous change request has been processed. Note that the change will become visible once the change request has been processed.`
    )}
  />
);
